// extracted by mini-css-extract-plugin
export default {"codeProvider":"xifd1","phoneNumber":"Tbtzw"};